export default __webpack_public_path__ + "static/bangles-be555258c5614c6d54bb58e4056c673e.png";